<div class="login-container" [class.mobile]="isMobile">
    <!-- Backdrop Dimming/Blur -->
    <div *ngIf="showCompanySelection" class="login-backdrop"></div>

    <div class="login-box" [class.with-selection]="showCompanySelection">
        <!-- Botão Voltar (Apenas na seleção de empresa) -->
        <button *ngIf="showCompanySelection" class="back-button" (click)="hideCompanySelection()">
            <lucide-angular [img]="AlertCircle" size="14"></lucide-angular> VOLTAR
        </button>

        <div class="login-header" [class.dimmed]="showCompanySelection">
            <img src="/assets/LOGOMARCA - GLOBAL PARTS.png" alt="Global Parts" class="login-logo" />
            <p class="login-title">
                {{ showCompanySelection ? 'Selecione a Unidade' : 'Acesso Restrito' }}
            </p>
        </div>

        <div *ngIf="error && !showCompanySelection" class="error-message">
            <lucide-angular [img]="AlertCircle" size="18"></lucide-angular>
            <span>{{ error }}</span>
        </div>

        <form (ngSubmit)="handleLogin()" class="login-form">
            <div class="form-group" [class.dimmed]="showCompanySelection">
                <label class="form-label">Usuário</label>
                <div class="input-wrapper">
                    <input
                        type="text"
                        name="username"
                        placeholder="Seu usuário"
                        [(ngModel)]="username"
                        [disabled]="showCompanySelection"
                        required
                        class="form-input"
                        [class.campo-obrigatorio-pulse]="camposObrigatoriosPulse && !username.trim()"
                    />
                    <lucide-angular [img]="User" class="input-icon" size="20"></lucide-angular>
                </div>
            </div>

            <div class="form-group" [class.dimmed]="showCompanySelection">
                <label class="form-label">Senha</label>
                <div class="input-wrapper">
                    <input
                        [type]="showPassword ? 'text' : 'password'"
                        name="password"
                        placeholder="Sua senha"
                        [(ngModel)]="password"
                        [disabled]="showCompanySelection"
                        required
                        class="form-input password"
                        [class.campo-obrigatorio-pulse]="camposObrigatoriosPulse && !password.trim()"
                        (keyup)="verificarCapsLock($event)" 
                        (keydown)="verificarCapsLock($event)"
                    />
                    <lucide-angular [img]="Lock" class="input-icon" size="20"></lucide-angular>
                    <button
                        *ngIf="!showCompanySelection"
                        type="button"
                        (click)="togglePassword()"
                        class="toggle-password"
                    >
                        <lucide-angular *ngIf="showPassword" [img]="EyeOff" size="20"></lucide-angular>
                        <lucide-angular *ngIf="!showPassword" [img]="Eye" size="20"></lucide-angular>
                    </button>
                    <small *ngIf="capsLockAtivado" style="color: #ef4444; font-weight: bold; display: flex; align-items: center; gap: 5px; margin-top: 4px;">
                        <i class="fa fa-exclamation-triangle"></i> 
                        Atenção: Caps Lock está ativado!
                    </small>
                </div>
            </div>

            <!-- Campo Independente de Empresa/Unidade (Aparece após login) -->
            <label *ngIf="!showCompanySelection" class="keep-connected-option">
                <input
                    type="checkbox"
                    name="manterConectado"
                    [(ngModel)]="manterLogado"
                />
                <span>Manter Conectado</span>
            </label>
            <div *ngIf="showCompanySelection" class="company-selection-container">
                <label class="company-selection-label">Selecionar Unidade</label>
                <div class="company-selection-box">
                    <lucide-angular [img]="LogIn" class="company-selection-icon" size="20"></lucide-angular>
                    <span style="flex: 1">Empresas Disponíveis</span>
                    <lucide-angular [img]="ChevronRight" style="transform: rotate(90deg); color: #4f46e5;" size="18"></lucide-angular>
                </div>

                <!-- Dropdown de Unidades -->
                <div class="company-selection-dropdown">
                    <div class="company-list">
                        <button
                            *ngFor="let company of availableCompanies"
                            type="button"
                            (click)="selectCompany(company)"
                            class="company-button"
                            [ngStyle]="{'background-color': getCompanyStyle(company.id).bg, 'border': '1.5px solid ' + getCompanyStyle(company.id).border}"
                        >
                            <div class="company-dot" [ngStyle]="{'background-color': getCompanyStyle(company.id).border}"></div>
                            <span class="company-name">
                                {{ cleanCompanyName(company.nome) }}
                            </span>
                            <lucide-angular [img]="ChevronRight" size="14" [color]="getCompanyStyle(company.id).border"></lucide-angular>
                        </button>
                    </div>
                </div>
            </div>

            <button *ngIf="!showCompanySelection" type="submit" [disabled]="loading" class="submit-button">
                <ng-container *ngIf="loading">
                    <app-loading-indicator size="inline"></app-loading-indicator>
                </ng-container>
                <ng-container *ngIf="!loading">
                    <lucide-angular [img]="LogIn" size="20"></lucide-angular>
                    <span>ENTRAR</span>
                </ng-container>
            </button>
        </form>
    </div>
</div>
